import Node from './Node';
import ValueNode from './ValueNode';
import TextType from './TextType';

abstract class BinaryNode extends ValueNode<Node[]> {

	public constructor (left: Node, right: Node) {
		super([left, right]);
	}

	public getLeft () {
		return this.getValue()[0];
	}

	public getRight () {
		return this.getValue()[1];
	}

	public normalized () {
		const sortedLeftNode = this.getLeft().normalized();
		const sortedRightNode = this.getRight().normalized();

		return sortedLeftNode.toText() < sortedRightNode.toText() ? this.create(sortedLeftNode, sortedRightNode) : this.create(sortedRightNode, sortedLeftNode);
	}

	public toText (textType = TextType.PLAIN) {
		return this.getTextPrefix(textType) + this.getLeft().toText(textType) + this.getTextInfix(textType) + this.getRight().toText(textType) + this.getTextPostfix(textType);
	}

	protected abstract create (left: Node, right: Node): BinaryNode;

	protected getTextPrefix (textType?: TextType): string {
		return '(';
	}

	protected abstract getTextInfix (textType?: TextType): string;

	protected getTextPostfix (textType?: TextType): string {
		return ')';
	}
}

export default BinaryNode;


// WEBPACK FOOTER //
// ./code/project/modules/parsing/nodes/BinaryNode.ts